// extracted by mini-css-extract-plugin
export var agreeContainer = "bugCrowdForm-module--agreeContainer--3965c";
export var btn = "bugCrowdForm-module--btn--89dec";
export var btnPrimary = "bugCrowdForm-module--btnPrimary--9b661";